import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import ExampleCards from '@view/page_v3/CreativeToImage/components/ExampleCards';
import AddNodePopover from '../AddNodePopover';
import styles from './index.module.scss';

const CanvasEmpty = ({ onSelectExample, onAddNode }) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                <ExampleCards onSelectCard={onSelectExample} className={styles.exampleCards} />
                <AddNodePopover placement="bottom" onSelect={onAddNode}>
                    <div className={styles.freeNode}>
                        <span className={styles.freeNodeIcon}>
                            <PlusOutlined style={{ fontSize: 12, color: '#006EFF' }} />
                        </span>
                        <span className={styles.freeNodeText}>自由节点</span>
                    </div>
                </AddNodePopover>
            </div>
        </div>
    );
};

export default CanvasEmpty;
